import { render, staticRenderFns } from "./RegionDetails.vue?vue&type=template&id=3e4656b8"
import script from "./RegionDetails.vue?vue&type=script&lang=js"
export * from "./RegionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e4656b8')) {
      api.createRecord('3e4656b8', component.options)
    } else {
      api.reload('3e4656b8', component.options)
    }
    module.hot.accept("./RegionDetails.vue?vue&type=template&id=3e4656b8", function () {
      api.rerender('3e4656b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/RegionDetails.vue"
export default component.exports